import { cP, cPforBLeanOnly, cPforFLeanOnly, cPforLLeanOnly, cPforRLeanOnly, IsNumeric } from "../../redux/reducers/building_pricing/pricingReducer";
import { const_var, params } from "../../redux/reducers/reducer";
import { getBuildingDoorWindowPricing, getBuildingLeanToPrice, getBuildingPricing } from "../../services/building-service";

export const getUpdatedPriceDataFlags = () => ({
	roof_style_price_changed: true,
	lifttype_price_changed: true,
	cupola_price_changed: true,
	width_price_changed: true,
	length_price_changed: true,
	height_price_changed: true,
	left_wall_price_changed: true,
	right_wall_price_changed: true,
	right_wall_cut_panel_price_changed: true,
	left_wall_cut_panel_price_changed: true,
	front_wall_price_changed: true,
	back_wall_price_changed: true,
	certificate_price_changed: true,
	common_width_changed: true,
	common_length_changed: true,
	common_height_changed: true,
	utility_price_changed: true,
	front_utility_price_changed: true,
	wainscot_price_changed: true,
	connection_fee_end_changed: true,
	connection_fee_side_changed: true,
	roof_pitch_price_changed: true,
	left_lean_roof_style_price_changed: true,
	left_lean_width_price_changed: true,
	left_lean_length_price_changed: true,
	left_lean_height_price_changed: true,
	left_lean_left_wall_price_changed: true,
	left_lean_front_wall_price_changed: true,
	left_lean_back_wall_price_changed: true,
	left_lean_certificate_price_changed: true,
	left_lean_utility_price_changed: true,
	left_lean_roof_pitch_price_changed: true,
	right_lean_roof_style_price_changed: true,
	right_lean_width_price_changed: true,
	right_lean_length_price_changed: true,
	right_lean_height_price_changed: true,
	right_lean_right_wall_price_changed: true,
	right_lean_front_wall_price_changed: true,
	right_lean_back_wall_price_changed: true,
	right_lean_certificate_price_changed: true,
	right_lean_utility_price_changed: true,
	right_lean_roof_pitch_price_changed: true,
	front_lean_roof_style_price_changed: true,
	front_lean_width_price_changed: true,
	front_lean_length_price_changed: true,
	front_lean_height_price_changed: true,
	front_lean_left_wall_price_changed: true,
	front_lean_front_wall_price_changed: true,
	front_lean_back_wall_price_changed: true,
	front_lean_certificate_price_changed: true,
	front_lean_utility_price_changed: true,
	front_lean_roof_pitch_price_changed: true,
	back_lean_roof_style_price_changed: true,
	back_lean_width_price_changed: true,
	back_lean_length_price_changed: true,
	back_lean_height_price_changed: true,
	back_lean_left_wall_price_changed: true,
	back_lean_front_wall_price_changed: true,
	back_lean_back_wall_price_changed: true,
	back_lean_certificate_price_changed: true,
	back_lean_utility_price_changed: true,
	back_lean_roof_pitch_price_changed: true,
	color_price_changed: true,
	left_front_wrap_connection_fee_changed: true,
	right_front_wrap_connection_fee_changed: true,
	right_back_wrap_connection_fee_changed: true,
	left_back_wrap_connection_fee_changed: true,
	front_lean_insulation_price_changed: true,
	left_lean_insulation_price_changed: true,
	right_lean_insulation_price_changed: true,
	back_lean_insulation_price_changed: true,
	wall_color_price_changed: true,
	roof_color_price_changed: true,
	trim_color_price_changed: true,
	left_lean_right_wall_price_changed: true,
	right_lean_left_wall_price_changed: true,
	front_lean_right_wall_price_changed: true,
	back_lean_right_wall_price_changed: true,
	siding_material_price_changed: true,
	frontLean_truss_price_changed: true,
	backLean_truss_price_changed: true,
	rightLean_truss_price_changed: true,
	leftLean_truss_price_changed: true,
	common_left_lean_length_changed: true,
	common_right_lean_length_changed: true,
	common_front_lean_length_changed: true,
	common_back_lean_length_changed: true,
	common_left_lean_width_changed: true,
	common_right_lean_width_changed: true,
	common_front_lean_width_changed: true,
	common_back_lean_width_changed: true
});
export const updatePriceCalculation = (newVal, oldVal, pointKey, leanVal, objIndex, uniqueId, elementObjIndex, extraItemType, cupolaId, isforanchor) => {
	let data = IsNumeric(newVal);
	let finalPrice = 0;
	newVal = newVal.replace(/^0+/, "");
	var regex = /^\d+(\.\d{0,2})?$/g;
	if (pointKey == "roof_color_price") {
		const_var.colorPrice["roof_color_price_changed"] = true;
	}
	if (pointKey == "wall_color_price") {
		const_var.colorPrice["wall_color_price_changed"] = true;
	}
	if (pointKey == "trim_color_price") {
		const_var.colorPrice["trim_color_price_changed"] = true;
	}
	if (pointKey == "wainscot_color_price") {
		const_var.colorPrice["wainscot_color_price_changed"] = true;
	}
	if (pointKey == "truss_price") {
		if (leanVal) {
			const_var.UpdatedPriceData[`${leanVal}Lean_truss_price_changed`] = undefined;
		} else {
			const_var.UpdatedPriceData.truss_price_changed = undefined;
		}
	}

	if (pointKey == "roof_style_price") {
		const_var.UpdatedPriceData.truss_price_changed = true;
		const_var.UpdatedPriceData.down_payment_discount_rate_Updated = undefined;
	}
	if (pointKey == "siding_material_price") {
		const_var.check_siding_material_price = true;
	}
	let updateWainscotPrice = false;
	if (const_var.wainscot_filter_data?.length > 0 && const_var.wainscot_filter_data?.[0].price_type != "$") {
		updateWainscotPrice = true;
	} else if (const_var.wainscot_metal.price_type != "$") {
		updateWainscotPrice = true;
	}
	if (pointKey != "wainscot_price" && params.p_w_c_n && updateWainscotPrice) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
	}
	if (pointKey == "wainscot_price") {
		const_var.isWainscotManualPriceUpdate = true;
	}
	if (pointKey == "extra_labour") {
		const_var.is_edit_extra_labour = true;
	}

	if (!regex.test(newVal)) {
		if (isNaN(parseFloat(newVal)) == true || newVal == "") {
			newVal = 0;
		} else {
			newVal = newVal.split(".");
			newVal = newVal[0] + "." + newVal[1].substring(0, 2);
		}
	}

	if (isNaN(parseFloat(newVal)) == true) {
		newVal = 0;
		const_var.UpdatedPriceData[pointKey] = 0;
	}
	if (oldVal != "extraitems" && leanVal == undefined) {
		if (pointKey == "processing_fee" && const_var.card_processing_fee != undefined) {
			const_var.card_processing_fee.is_edit = true;
		}
		if (pointKey == "extra_labour") {
			const_var.is_edit_labour = true;
		}
		if (const_var.order_extra_items[pointKey] != undefined) {
			const_var.order_extra_items[pointKey] = newVal;
		} else {
			const_var.UpdatedPriceData[pointKey] = newVal;
		}
	}
	let holdComponentIndex = "";
	if (uniqueId != undefined) {
		var ii = const_var.entry_points.length;

		while (ii--) {
			if (const_var.entry_points[ii].uniqueId == uniqueId) {
				holdComponentIndex = ii;

				const_var.entry_points[ii][pointKey] = newVal;
				const_var.entry_points[ii]["is_price_updated"] = true;
				if (const_var.garageDoorColor[params.g_d_c_id] != undefined && const_var.garageDoorColor[params.g_d_c_id].percentage_of_cost > 0) {
					const_var.entry_points[ii].entry_garageDoor_color_price = (const_var.entry_points[ii].entry_price * const_var.garageDoorColor[params.g_d_c_id].cost) / 100;
				}
			}
		}
		if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
		}
	}
	if (const_var.isLTBuilding && isforanchor && pointKey && const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]?.[pointKey]?.item_quantity) {
		const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"][pointKey].item_price = newVal || 0;
	}

	let cupolaIndex = "";
	if (cupolaId != undefined) {
		let cupolaEntriesLength = const_var.cupolaEntries.length;
		while (cupolaEntriesLength--) {
			if (const_var.cupolaEntries[cupolaEntriesLength].uniqueId == cupolaId) {
				cupolaIndex = cupolaEntriesLength;
				const_var.cupolaEntries[cupolaEntriesLength][pointKey] = newVal;
			}
		}
	}
	if (
		const_var.selectedLeanType !== "" &&
		const_var.isLTBuilding &&
		oldVal == "extraitems" &&
		leanVal == undefined &&
		pointKey != undefined &&
		pointKey != "" &&
		(pointKey?.toLowerCase()?.includes("overhang") || pointKey?.toLowerCase() === "4ft on center" || pointKey?.toLowerCase()?.includes("jtrim"))
	) {
		if (const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"][pointKey]) {
			const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"][pointKey].item_price = newVal;
			const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"][pointKey].is_edit = true;
		}
	} else if (
		oldVal == "extraitems" &&
		leanVal == undefined &&
		pointKey != undefined &&
		pointKey != "" &&
		pointKey != "Side Cross Bracing" &&
		pointKey != "End Cross Bracing" &&
		const_var.UpdatedPriceData.elements[pointKey] != undefined
	) {
		if (const_var.isLTBuilding) {
			const selectedLeanType = const_var.selectedLeanType === "" ? "centerBuilding" : const_var.selectedLeanType;
			const_var.lNTBuildingData["updatePriceDataElements"][selectedLeanType][pointKey].item_price = newVal;
			const_var.lNTBuildingData["updatePriceDataElements"][selectedLeanType][pointKey].is_edit = true;

			if (elementObjIndex !== undefined && extraItemType == "extraitemsCheckboxwithQuantity") {
				const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[selectedLeanType][elementObjIndex].cost = newVal;
			}
		} else {
			const_var.UpdatedPriceData["elements"][pointKey].item_price = newVal;
			const_var.UpdatedPriceData["elements"][pointKey].is_edit = true;

			if (elementObjIndex !== undefined && extraItemType == "additionalFeatures") {
				const_var.UpdatedPriceData["elements"][pointKey.toString()].item_price = newVal;
				const_var.UpdatedPriceData["elements"][pointKey.toString()].is_edit = true;
			}

			if (elementObjIndex !== undefined && extraItemType == "extraitemsCheckboxwithQuantity") {
				const_var.ExtraItemsFeaturesQuantityArray[elementObjIndex].cost = newVal;
			}
		}
	} else if (
		oldVal == "extraitems" &&
		leanVal == undefined &&
		pointKey != undefined &&
		pointKey != "" &&
		(pointKey == "Side Cross Bracing" || pointKey == "End Cross Bracing") &&
		const_var.UpdatedPriceData.elements[pointKey] == undefined
	) {
		let findBracingObj = Object.keys(const_var.UpdatedPriceData.elements).find(
			(key) => const_var.UpdatedPriceData.elements[key]?.other_item_name && const_var.UpdatedPriceData.elements[key]?.other_item_name == pointKey
		);
		if (const_var.isLTBuilding) {
			const selectedLeanType = const_var.selectedLeanType === "" ? "centerBuilding" : const_var.selectedLeanType;
			const_var.lNTBuildingData["updatePriceDataElements"][selectedLeanType][findBracingObj].item_price = newVal;
			const_var.lNTBuildingData["updatePriceDataElements"][selectedLeanType][findBracingObj].is_edit = true;

			if (elementObjIndex !== undefined && extraItemType == "extraitemsCheckboxwithQuantity") {
				const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[selectedLeanType][elementObjIndex].cost = newVal;
			}
		} else {
			const_var.UpdatedPriceData["elements"][findBracingObj].item_price = newVal;
			const_var.UpdatedPriceData["elements"][findBracingObj].is_edit = true;

			if (elementObjIndex !== undefined && extraItemType == "additionalFeatures") {
				const_var.UpdatedPriceData["elements"][findBracingObj.toString()].item_price = newVal;
				const_var.UpdatedPriceData["elements"][findBracingObj.toString()].is_edit = true;
			}

			if (elementObjIndex !== undefined && extraItemType == "extraitemsCheckboxwithQuantity") {
				const_var.ExtraItemsFeaturesQuantityArray[elementObjIndex].cost = newVal;
			}
		}
	}
	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0 && const_var.c_f_aCer[params.p_e_i] != undefined && pointKey != "certificate_price") {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	if (leanVal != undefined) {
		if (const_var.UpdatedPriceData.leanto.length > 0) {
			const_var.UpdatedPriceData.leanto[objIndex][pointKey] = newVal;

			if (leanVal == "left") {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
				cPforLLeanOnly(const_var.leanGetDataLeft, objIndex, const_var.UpdatedPriceData.leanto[objIndex]);
			}
			if (leanVal == "right") {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
				cPforRLeanOnly(const_var.leanGetDataRight, objIndex, const_var.UpdatedPriceData.leanto[objIndex]);
			}
			if (leanVal == "front") {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
				cPforFLeanOnly(const_var.leanGetDataFront, objIndex, const_var.UpdatedPriceData.leanto[objIndex]);
			}
			if (leanVal == "back") {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
				cPforBLeanOnly(const_var.leanGetDataBack, objIndex, const_var.UpdatedPriceData.leanto[objIndex]);
			}
		}
	} else {
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		cP("", undefined, holdComponentIndex);
		const_var.check_siding_material_price = false;
	}
};
export const formatOverhangData = (overhangData = {}) => {
	const convertOverhang = (item) => ({
		id: item?.id,
		sheet_name: item?.name,
		sheet_type: item?.overhang_type?.toLowerCase()?.replace("_overhang", ""),
		cost: item?.price,
		cost_type: item?.price_type
	});

	return Object.keys(overhangData)?.reduce((acc, key) => {
		acc[key] = (overhangData[key] || []).map(convertOverhang);
		return acc;
	}, {});
};
export const formatRoofPitchData = (data = []) => {
	return data
		.map((item) => ({
			id: item?.id || null,
			percentage_of: item?.percentage_of || null,
			roof_ids: item?.roof_ids ? item.roof_ids.join(",") : null,
			roof_pitch: item?.roof_pitch ? item.roof_pitch.replace("_", "/") : null,
			cost_type: item?.cost_type || "$",
			doc: item?.doc || 0,
			cost: item?.cost || 0,
			is_default: item?.is_default ? "yes" : "no"
		}))
		.sort((a, b) => {
			const aPitch = Number(a.roof_pitch?.split("/")[0] || 0);
			const bPitch = Number(b.roof_pitch?.split("/")[0] || 0);
			return aPitch - bPitch;
		});
};

export const getGaugeRoofCost = (baseData, prs, gauge) => {
	const gaugeObj = baseData?.find((g) => Number(g.gauge) === Number(gauge));

	const roofObj = gaugeObj?.base_cost?.find((r) => Number(r.roof_type) === Number(prs));
	return Number(roofObj?.gauges?.[0]?.cost || 0);
};

export const formatInsulationData = (data = []) => {
	return data.map((item, index) => ({
		cost: item?.unit_price ?? item?.cost ?? 0,
		insulation_id: index + 1,
		end_cost: item?.end_cost ?? 0,
		full_building_insulation_cost: item?.full_building_insulation_cost ?? 0,
		name: item?.name ?? null,
		open_roof_cost: item?.open_roof_cost ?? 0,
		pitch_type: item?.pitch_type,
		roof_insulation_cost: item?.roof_insulation_cost ?? 0,
		side_cost: item?.side_cost ?? 0
	}));
};
export const formatConnectionFees = (data = []) => {
	if (!Array.isArray(data) || data.length === 0) {
		return [];
	}

	const result = {
		width: 0,
		length: 0,
		cost: 0,
		end_cost: 0,
		wrap_around_cost: 0,
		end_leanto_cost: 0,
		added_building_cost: 0,
		length_without_wrap: 0
	};

	data.forEach((item) => {
		if (item.width != null) result.width = item.width;
		if (item.length != null) result.length = item.length;

		if (item.connection_category === "END_CONNECTION") {
			result.end_cost = item.price ?? 0;
		}

		if (item.connection_category === "END_LEAN_TO_COST") {
			result.end_leanto_cost = item.price ?? 0;
		}
	});

	return [result];
};
export const setTrussType = ({ dataNew, params, state, const_var }) => {
	if (dataNew?.truss_name?.length > 0) {
		state.const_var.c_m_a[state.params.p_b_t].trussType = dataNew.truss_name;
		let trussAccordingWidth = dataNew.truss_name.filter((data) => params.p_w >= data.min_width && params.p_w <= data.max_width);
		state.const_var.c_m_a[state.params.p_b_t].trussType = trussAccordingWidth;
		if (const_var.crmSetting.is_Edit == true && params.newtrussType != "" && dataNew.truss_name.length > 0) {
			let filterDatan = dataNew.truss_name.filter((data) => data.name.includes(params.newtrussType));

			if (filterDatan.length > 0) {
				params.trussType = params.newtrussType;
			}
		} else {
			params.trussType = trussAccordingWidth?.[0]?.name;
		}
	}
};
export function formatTrussOptionsByGauge(trussData = [], gauge) {
	if (!Array.isArray(trussData) || !gauge) return [];

	const gaugeData = trussData.find((item) => String(item.gauge) === String(gauge));
	if (!gaugeData?.truss_options) return [];
	return gaugeData.truss_options.map((option) => ({
		label: option.name,
		name: option.truss_type,
		min_width: option?.min_width,
		max_width: option.max_width,
		cost: option.cost,
		price_type: option.price_type ?? "$",
		price_of: option.price_of ?? null,
		is_default: option.is_default ? 1 : 0,
		is_show: option.is_show ? 1 : 0
	}));
}
export function SidePanelfilterByMaterialSlug(data) {
	if (!data) return { side: [], panel: [] };

	const mapSide = (item) => ({
		...item,
		leg_height_cost: item.leg_height_cost || 0,
		double_leg_baserail_cost: item.double_leg_baserail_cost || 0,
		double_leg_baserail_cost_12: item.double_leg_baserail_cost_12 || 0,
		ladder_cost: item.ladder_cost || 0
	});

	const mapPanel = (item) => ({
		...item,
		is_panel_jtrim: item.is_panel_jtrim?.toLowerCase() || "no",
		is_cut_panel_jtrim: item.is_cut_panel_jtrim?.toLowerCase() || "no",
		cost: item.horizontal_panel_cost || 0,
		cut_panel_cost: item.horizontal_cut_panel_cost || item.vertical_cut_panel_cost || 0
	});

	return {
		side: data.side?.map(mapSide) || [],
		panel: data.panel?.map(mapPanel) || []
	};
}

export function EndPanelfilterByMaterialSlug(data) {
	if (!data) return { end: [], panel: [] };

	const mapEnd = (item) => ({
		...item
	});

	const mapEndPanel = (item) => ({
		...item,
		is_jtrim: item?.is_end_panel_jtrim?.toLowerCase() || "no",
		jtrim: item?.end_panel_jtrim,
		uncertified: 0,
		certified: 0,
		vertical: item?.vertical_gabel_end_certified_panel_cost || 0,
		extended: 465,
		vertical_extended: item?.vertical_extended_gabel_end_certified_panel_cost || 0,
		vertical_certified: 60
	});

	return {
		end: data.end?.map(mapEnd) || [],
		panel: data.panel?.map(mapEndPanel) || []
	};
}
export const getBuildingPricingData = async () => {
	const { p_u_c, p_u_t, cB_addStorage_check_left, cB_addStorage_check_right, p_b_t, p_w } = params;
	const isNotBack = const_var.post_data?.building?.utility_name !== "back";
	const hasSideStorage = cB_addStorage_check_left || cB_addStorage_check_right;
	try {

		const componentResponse = await getBuildingDoorWindowPricing({
				manufacturerId: "122",
				buildingId: const_var.c_m_a[params.p_b_t].uniqueBuildingId,
				priceBookId:  const_var.c_m_a[params.p_b_t].uniquePriceBookId,
				roofId: String(params.p_r_s),
				frameGauge: 12,
		})
		const apiData = {
			manufacturerId: "122",
			buildingId: const_var.c_m_a[params.p_b_t].uniqueBuildingId,
			priceBookId: const_var.c_m_a[params.p_b_t].uniquePriceBookId,
			roofId: String(params.p_r_s),
			frameGauge: "12",
			width: params.p_w,
			length: params.p_d,
			height: params.p_h,
			sub_material_id: const_var.selSidingObj?.materialSubTypeId,
			...(isNotBack &&
				p_u_c && {
					utility_length:
						//  p_u_t
						20
				}),

			...(hasSideStorage && {
				utility_width:
					//  p_b_t == "2" ? (p_w + 24) / 2 : p_w / 2
					12
			})
		};
		const AllBuilding = const_var?.building;
		const newPricingRes = await getBuildingPricing(apiData);
		const newPricing = newPricingRes?.data || {};

		const NewSidepanelData = SidePanelfilterByMaterialSlug(newPricing?.side_panel, const_var.selSidingOption);
		const NewEndpanelData = EndPanelfilterByMaterialSlug(newPricing?.end_panel, const_var.selSidingOption);
		const trussOptions = formatTrussOptionsByGauge(newPricing?.truss, params.gauge_val);
  
		const response = {
			data: {
				success: true,
				message: "success",
				data: {
					manufacturer: newPricing?.manufacturers,
					overhang: formatOverhangData(newPricing?.overhang ?? []),
					roof_pitch: formatRoofPitchData(newPricing?.roof_pitch ?? []),
					insulation: formatInsulationData(newPricing?.insulation ?? []),
					building_structure: newPricing?.building_structure,
					base: newPricing?.base ?? [],
					connection_fees: formatConnectionFees(newPricing?.connection_fees ?? []),
					truss_name: trussOptions,
					side: NewSidepanelData?.side ?? [],
					panel: NewSidepanelData?.panel ?? [],
					end: NewEndpanelData?.end ?? [],
					gable_end: NewEndpanelData?.panel ?? [],
					anchors_cost: newPricing?.anchors,
					wainscot: newPricing.wainscot,
					drawings: newPricing.drawings || [],
					utility_side: newPricing?.storage_price?.side || [],
					side_combo_v3: newPricing?.storage_price?.side || [],
					end_combo_v3: newPricing?.storage_price?.end || []
				}
			}
		};
		const garageDoorV3 = componentResponse?.data?.garage_doors;
        const walkInDoorV3 = componentResponse?.data?.walk_in_doors;
        const windowV3 = componentResponse?.data?.windows;
        const frameOuts = componentResponse?.data?.frame_outs??[];
         response.data.data = {
                ...response.data.data,
                garage_door_v3 :garageDoorV3??[],
                garage_door_frameout:frameOuts.filter(frame=>frame.frame_out_type === "garage_door_frame_out") ??[],
                walkin_door_v3 :walkInDoorV3??[],
                walkin_door_frameout_v3 : frameOuts.filter(frame=>frame.frame_out_type === "walk_in_door_frame_out")??[], 
                window_v3:windowV3,
                window_frameout_v3 : frameOuts.filter(frame=>frame.frame_out_type === "window_frame_out")??[], 
		}
		return {response,componentResponse};
	} catch (error) {
		console.error("Building Pricing Error:", error);
		throw error;
	}
};
export const getLeanToBuildingPricing = async () => {
	try {
		const LeanApiPayload = {
			buildingId: const_var.c_m_a[params.p_b_t]?.uniqueLeanId,
			frameGauge: "12",
			height: params.lean_p_h,
			length: params.lean_p_d,
			roofId: String(params.p_r_s),
			manufacturerId: "122",
			priceBookId: const_var.c_m_a[params.p_b_t].uniquePriceBookId,
			width: params.lean_p_w,
			centralBuildingId: const_var.c_m_a[params.p_b_t].uniqueBuildingId,
			centralWidth: params.p_w,
			centralLength: params.p_d,
			centralHeight: params.p_h,
			centralPitchType: "4_12",
			central_utility_length:
				//  p_u_t
				20,
			central_utility_width:
				//  p_b_t == "2" ? (p_w + 24) / 2 : p_w / 2
				0,
			sub_material_id: const_var.selSidingObj?.materialSubTypeId,
			central_sub_material_id: const_var.selSidingObj?.materialSubTypeId,
			utility_length: 20,
			docId: "a94d7426-8b11-42f1-91e9-0afddd879da2"
		};
		const newLeanPricingRes = await getBuildingLeanToPrice(LeanApiPayload);
		const newLeanPricing = newLeanPricingRes?.data || {};

		const NewLeanSidepanelData = SidePanelfilterByMaterialSlug(newLeanPricing?.side_panel, const_var.selSidingOption);
		const NewLeanEndpanelData = EndPanelfilterByMaterialSlug(newLeanPricing?.end_panel, const_var.selSidingOption);
		const CentralSidepanelData = SidePanelfilterByMaterialSlug(newLeanPricing?.central_building_price?.side_panel, const_var.selSidingOption);
		const CentralEndpanelData = EndPanelfilterByMaterialSlug(newLeanPricing?.central_building_price?.end_panel, const_var.selSidingOption);
		const trussOptions = formatTrussOptionsByGauge(newLeanPricing?.truss, params.gauge_val);

		const response = {
			data: {
				success: true,
				message: "success",
				data: {
					overhang: formatOverhangData(newLeanPricing?.overhang ?? []),
					roof_pitch: formatRoofPitchData(newLeanPricing?.roof_pitch ?? []),
					insulation: formatInsulationData(newLeanPricing?.insulation ?? []),
					building_structure: newLeanPricing?.central_building_price?.building_structure,
					full_length_side: NewLeanSidepanelData?.side ?? [],
					base: newLeanPricing?.base ?? [],
					connection_fees: formatConnectionFees(newLeanPricing?.connection_fees ?? []),
					truss_name: trussOptions,
					side: NewLeanSidepanelData?.side ?? [],
					panel: NewLeanSidepanelData?.panel ?? [],
					end: NewLeanEndpanelData?.end ?? [],
					gable_end: NewLeanEndpanelData?.panel ?? [],
					anchors_cost: newLeanPricing?.anchors,
					central_building_structure: newLeanPricing?.lean_to_building?.building_structure,
					central_side: CentralSidepanelData?.side ?? [],
					central_panel: CentralSidepanelData?.panel ?? [],
					central_end: CentralEndpanelData?.end ?? [],
					central_insulation: formatInsulationData(newLeanPricing?.central_building_price?.insulation ?? []),
					central_side_full_length: CentralSidepanelData?.side ?? [],
					utility_side: newLeanPricing?.storage_price?.side || [],

					side_combo_v3: newLeanPricing?.central_building_price?.storage_price?.side || [],
					end_combo_v3: newLeanPricing?.central_building_price?.storage_price?.end || []
				}
			}
		};
		return response;
	} catch (error) {
		console.error("Building Pricing Error:", error);
		throw error;
	}
};
